export default __webpack_public_path__ + "static/media/CenturyGothicPaneuropeanLight.7278bbcb.ttf";